import {
	Notification,
	NOTIFICATION_STATUS,
	NOTIFICATION_TYPE,
	NotificationData,
} from '~/models/Notification'
import {
	API_NOTIFICATION_STATUS,
	API_NOTIFICATION_TYPE,
	ApiNotification,
	ApiNotificationData,
} from './apiTypes'
import { removeEmptyValues } from '~/models/helpers/removeUndefined'

export class NotificationEntityMapper {
	static toNotifications(items: ApiNotification[]): Notification[] {
		return items.map((item) => this.toNotification(item))
	}

	static toNotification(apiNotification: ApiNotification): Notification {
		const type = this.toNotificationType(apiNotification.type)
		const status = this.toNotificationStatus(apiNotification.status)
		return {
			id: apiNotification.id,
			type,
			status,
			created: new Date(apiNotification.created),
			data: this.mapData(apiNotification.data),
			cover: apiNotification.cover_url,
			message: apiNotification.message,
		}
	}

	private static mapData(apiData?: ApiNotificationData): NotificationData | undefined {
		if (!apiData) return
		const data = {
			userId: apiData.user_id,
			itineraryId: apiData.itinerary_id,
			taskId: apiData.task_id,
			invitationCode: apiData.invitation_code,
			invitationUrl: apiData.invitation_url,
		}
		return removeEmptyValues(data)
	}

	private static toNotificationType(apiType: API_NOTIFICATION_TYPE): NOTIFICATION_TYPE {
		const typeMap: Record<API_NOTIFICATION_TYPE, NOTIFICATION_TYPE> = {
			[API_NOTIFICATION_TYPE.TASK_ASSIGNED]: NOTIFICATION_TYPE.TASK_ASSIGNED,
			[API_NOTIFICATION_TYPE.TRIP_DELETED]: NOTIFICATION_TYPE.TRIP_DELETED,
			[API_NOTIFICATION_TYPE.TRIP_INVITATION_ACCEPTED]: NOTIFICATION_TYPE.TRIP_INVITATION_ACCEPTED,
			[API_NOTIFICATION_TYPE.TRIP_INVITATION_RECEIVED]: NOTIFICATION_TYPE.TRIP_INVITATION_RECEIVED,
			[API_NOTIFICATION_TYPE.TRIP_DATE_CHANGED]: NOTIFICATION_TYPE.TRIP_DATE_CHANGED,
			[API_NOTIFICATION_TYPE.TRIP_TITLE_CHANGED]: NOTIFICATION_TYPE.TRIP_TITLE_CHANGED,
			[API_NOTIFICATION_TYPE.WALL_PIN_CREATED]: NOTIFICATION_TYPE.WALL_PIN_CREATED,
			[API_NOTIFICATION_TYPE.WALL_PIN_DELETED]: NOTIFICATION_TYPE.WALL_PIN_DELETED,
			[API_NOTIFICATION_TYPE.BOOKING_CREATED]: NOTIFICATION_TYPE.BOOKING_CREATED,
			[API_NOTIFICATION_TYPE.FAVORITE_SPOT_CREATED]: NOTIFICATION_TYPE.SAVED_SPOT,
		}
		return typeMap[apiType]
	}

	private static toNotificationStatus(apiStatus: API_NOTIFICATION_STATUS): NOTIFICATION_STATUS {
		const statusMap: Record<API_NOTIFICATION_STATUS, NOTIFICATION_STATUS> = {
			[API_NOTIFICATION_STATUS.UNREAD]: NOTIFICATION_STATUS.UNREAD,
			[API_NOTIFICATION_STATUS.READ]: NOTIFICATION_STATUS.READ,
		}
		return statusMap[apiStatus]
	}
}
